import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AccessRequestInput } from '../../domain/models/access-request.model';
import { IAccessRequestRepository } from '../../domain/repositories/access-request.repository';
import { AccessRequestRemoteDatasource } from '../datasources/remote/access-request.remote-datasource';

@Injectable()
export class AccessRequestRepositoryImpl implements IAccessRequestRepository {
  private readonly datasource = inject(AccessRequestRemoteDatasource);

  public submit(input: AccessRequestInput): Observable<void> {
    return this.datasource.submit(input);
  }
}
